import React from 'react';
import PropTypes from 'prop-types';
import { taxonomyCollection } from 'lib/CustomPropTypes';
import classNames from 'classnames';

import styles from './styles.module.scss';

// supported content types with icons
const contentTypes = ['video', 'shop', 'recipe', 'relatedRecipe', 'slideshow', 'product'];

// SVG components to be able to control fill color
const playIcon = () => (
  <svg className={classNames(styles.svg, styles.video)} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="7.17188" cy="7" r="6.375" stroke="#FF503C" strokeWidth="1.25" />
      <path d="M5.07031 10.5V3.5L10.6703 7L5.07031 10.5Z" fill="#FF503C" />
    </g>
  </svg>
);

const shopIcon = () => (
  <svg className={styles.svg} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path className={styles.path} d="M9.33621 23.9645C10.4665 23.9645 11.3828 23.0483 11.3828 21.918C11.3828 20.7877 10.4665 19.8714 9.33621 19.8714C8.20593 19.8714 7.28966 20.7877 7.28966 21.918C7.28966 23.0483 8.20593 23.9645 9.33621 23.9645Z" fill="#231F20" />
    <path className={styles.path} d="M21.7422 23.9645C22.8725 23.9645 23.7888 23.0483 23.7888 21.918C23.7888 20.7877 22.8725 19.8714 21.7422 19.8714C20.6119 19.8714 19.6957 20.7877 19.6957 21.918C19.6957 23.0483 20.6119 23.9645 21.7422 23.9645Z" fill="#231F20" />
    <path className={styles.path} d="M24 12.21V4.91003C24 4.28762 23.4959 3.78349 22.8735 3.78349H6.37716C6.20066 3.78349 6 3.78349 5.84054 3.78349L5.3689 1.65527C5.28066 1.27225 4.93894 1 4.54559 1H0.844905C0.37833 1 0 1.37833 0 1.84491C0 2.31148 0.37833 2.68981 0.844905 2.68981H3.87342L7.42296 18.0699C7.51121 18.4529 7.85292 18.7252 8.24627 18.7252H22.9157C23.3823 18.7252 23.7606 18.3468 23.7606 17.8803C23.7606 17.4137 23.3823 17.0354 22.9157 17.0354H8.91844L8.43779 14.9531L22.8735 13.3366C23.5419 13.2408 24 12.8324 24 12.21Z" fill="#231F20" />
  </svg>
);

const recipeIcon = () => (
  <svg className={classNames(styles.svg, styles.recipe)} width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path className={styles.path} d="M14.4729 14.1796L7.02238 7.17899C7.46427 5.98259 6.88534 4.23595 5.49816 2.89282C3.82291 1.27316 1.60788 0.847086 0.55351 1.97577C-0.500863 3.10445 -0.00583887 5.30256 1.67221 6.92221C3.10414 8.31049 4.93322 8.80993 6.09386 8.22866L13.5192 15.2124C13.6547 15.3398 13.8347 15.4078 14.0198 15.4015C14.2049 15.3951 14.3799 15.3149 14.5065 15.1785C14.5694 15.1108 14.6185 15.0312 14.6509 14.9443C14.6833 14.8574 14.6984 14.7648 14.6953 14.672C14.6922 14.5792 14.6709 14.488 14.6328 14.4035C14.5946 14.319 14.5403 14.2429 14.4729 14.1796Z" />
    <path className={styles.path} d="M8.75684 12.3877L6.17476 15.1784C6.04504 15.2998 5.87449 15.3671 5.69752 15.3667C5.52055 15.3663 5.35032 15.2981 5.22117 15.1761C5.09202 15.054 5.01355 14.8871 5.0016 14.7089C4.98964 14.5308 5.04509 14.3547 5.15675 14.2162L7.73255 11.4255L8.25195 12.0839L8.75684 12.3877ZM19.7696 3.31309C19.7285 3.27599 19.6805 3.24743 19.6284 3.22904C19.5764 3.21066 19.5212 3.20282 19.4662 3.20596C19.4111 3.20911 19.3572 3.22318 19.3075 3.24737C19.2578 3.27157 19.2134 3.30541 19.1767 3.34695L17.149 5.64382L16.6428 5.17542L18.6872 2.86726C18.724 2.82576 18.7522 2.77737 18.7704 2.72485C18.7886 2.67232 18.7964 2.6167 18.7932 2.56115C18.7901 2.5056 18.7762 2.45122 18.7522 2.4011C18.7283 2.35099 18.6948 2.30612 18.6537 2.26906C18.6125 2.23201 18.5646 2.20349 18.5125 2.18514C18.4604 2.16679 18.4053 2.15896 18.3503 2.1621C18.2952 2.16525 18.2413 2.1793 18.1916 2.20346C18.142 2.22763 18.0975 2.26142 18.0608 2.30292L16.0247 4.60261L15.4654 4.09188C15.4744 4.08507 15.4828 4.07752 15.4905 4.06931L17.6189 1.66522C17.6592 1.62456 17.6909 1.57602 17.7121 1.52258C17.7332 1.46913 17.7433 1.4119 17.7418 1.35439C17.7402 1.29687 17.7271 1.24027 17.7031 1.18805C17.6792 1.13583 17.645 1.08908 17.6025 1.05066C17.56 1.01225 17.5103 0.982967 17.4562 0.964613C17.4022 0.946259 17.345 0.939217 17.2881 0.943917C17.2313 0.948617 17.176 0.96496 17.1256 0.991947C17.0753 1.01893 17.0309 1.056 16.9952 1.10088L14.8669 3.50497V3.52472L14.3075 2.99706L16.3044 0.70584C16.3786 0.622023 16.4167 0.511911 16.4104 0.399726C16.4041 0.287542 16.3539 0.182475 16.2708 0.107638C16.2297 0.0705833 16.1817 0.0420654 16.1297 0.0237129C16.0776 0.00536045 16.0225 -0.00246712 15.9674 0.000677112C15.8562 0.00702718 15.7521 0.0576823 15.6779 0.141499L13.5552 2.53995L12.3358 3.88026C11.9858 4.3089 11.77 4.8328 11.7158 5.38544C11.6615 5.93808 11.7712 6.49453 12.031 6.98413L7.73255 11.4255L8.25195 12.0839L8.75684 12.3877L12.9819 8.03945C13.5193 8.38651 14.1583 8.53769 14.7927 8.46789C15.4271 8.39808 16.0187 8.1115 16.4694 7.6557L17.6636 6.34078L17.6804 6.32103L17.7643 6.22791L19.7919 3.93951C19.8338 3.89829 19.8667 3.84869 19.8884 3.79388C19.9102 3.73908 19.9203 3.6803 19.9182 3.62131C19.9161 3.56231 19.9018 3.50442 19.8762 3.45134C19.8506 3.39826 19.8143 3.35117 19.7696 3.31309Z" />
  </svg>
);

const slideshowIcon = () => (
  <svg className={styles.svg} width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M13.6 0.8125H0.8V10.5625H0V0H13.6V0.8125ZM2.4 2.4375H16V13H2.4V2.4375ZM3.2 3.25H15.2V12.1875H3.2V3.25Z" fill="white" />
    <mask id="mask0_597_17791" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="13">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.6 0.8125H0.8V10.5625H0V0H13.6V0.8125ZM2.4 2.4375H16V13H2.4V2.4375ZM3.2 3.25H15.2V12.1875H3.2V3.25Z" fill="white" />
    </mask>
    <g mask="url(#mask0_597_17791)">
      <rect y="-1.625" width="15.9503" height="16.25" className={styles.path} />
    </g>
  </svg>
);

/**
 * Renders content type icon inline with text
 * @param {String|boolean} [type] - the content type icon to show
 * @param {String} [taxomony] - taxonomy object of the content item
 * used as a secondary option to set the icon type
 * @param {String} [size] - the size the icon should be
 * @param {String} [className] - additional classes for styling as needed
 * @returns {React.ReactElement}
 */
const TypeIconInline = ({
  type = false,
  taxonomy = null,
  size = 'small',
  className = null,
}) => {
  // get primary section taxonomy
  const primarySectionSlug = taxonomy?.primarySection?.slug;
  // check if content qualifies for an icon
  const iconType = contentTypes.includes(type)
    ? type : contentTypes.includes(primarySectionSlug) && primarySectionSlug;

  if (!iconType) return null;

  const classes = classNames(
    styles.container,
    styles[iconType],
    styles[size],
    className,
  );

  let svg = playIcon;
  if (iconType === 'shop' || iconType === 'product') {
    svg = shopIcon;
  } else if (iconType === 'recipe' || iconType === 'relatedRecipe') {
    svg = recipeIcon;
  } else if (iconType === 'slideshow') {
    svg = slideshowIcon;
  }

  if (iconType === 'shop') {
    return null;
  }

  return (
    <span
      className={classes}
      data-testid={iconType}
    >
      {svg()}
    </span>
  );
};

TypeIconInline.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  taxonomy: taxonomyCollection,
  size: PropTypes.string,
  className: PropTypes.string,
};


export { TypeIconInline };
